<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import DeviceTypeSelector from '@/components/Selector/components/DeviceTypeSelector.vue'
import type { DeviceFiltersType } from '@/types/filters/DeviceFilters'
import DebouncedInputField from '../../Fields/DebouncedInputField.vue'

type Props = {
    filters: DeviceFiltersType
}

defineProps<Props>()
type Emits = {
    (e: 'change', value: DeviceFiltersType): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" isResponsive>
        <DebouncedInputField
            :label="$t('device.filters.nameOrSerial')"
            :modelValue="filters.name?.toString()"
            @change="$emit('change', { name: $event })" />
        <DeviceTypeSelector
            :modelValue="
                filters.device_type_id ? parseInt(filters.device_type_id.toString()) : undefined
            "
            @select="$emit('change', { device_type_id: $event?.id })" />
    </StackLayout>
</template>
